import { render, staticRenderFns } from "./CodeMirrorEditor.vue?vue&type=template&id=08d22e57&scoped=true&"
import script from "./CodeMirrorEditor.vue?vue&type=script&lang=js&"
export * from "./CodeMirrorEditor.vue?vue&type=script&lang=js&"
import style0 from "./CodeMirrorEditor.vue?vue&type=style&index=0&id=08d22e57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d22e57",
  null
  
)

export default component.exports